// Example of url w/ UTM params :
// panfoundation.org/ask-congress-to-lower-out-of-pocket-costs/?utm_source=send3a&utm_medium=email&utm_campaign=2020_oct&c_src=email&c_src2=send3a

// Example of classy donation form: https://donate.panfoundation.org/give/290725/#!/donation/checkout

const init = () => {
    appendParams();
  };

// Find all links to classy donation form on page.
let classyLinks = document.querySelectorAll('a[href^="https://donate.panfoundation.org/give/290725/#!/donation/checkout"]');


let utmParams = getUrlVars();

// Get the UTM params
function getUrlVars() {

    let paramVars = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        paramVars[key] = value;
    });
    return paramVars;
}


function appendParams() {

    if(Object.keys(utmParams).length !== 0){

    let paramString= [];

    for (const [key, value] of Object.entries(utmParams)) {

        let keyAndValues = `${key}=${value}`;
        // push all the param values converted to string
        paramString.push(keyAndValues);

      }

    let joinedParamString = paramString.join('&');

    // Add params to classy donate links
    classyLinks.forEach(function(el) {
      el.href = el.href + '?' + joinedParamString;
      // let itemHref = el.href;
    });
    } else {
      // do nothing
    }
}

// Init on initial page load
init();
